// import { BsThreeDotsVertical } from "react-icons/bs";
// import { AiOutlineEye } from "react-icons/ai";

import axios from "axios";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const SameCustomerList = ({ header, handleDetails, similarCustomer, token, selectedOutlet, url, fetchSelectedData }) => {
  const [showModal, setShowModal] = useState(false);
  const [guestName, setGuestName] = useState("");
  const [guestID, setGuestID] = useState("");
  const [panNo, setPanNo] = useState("");

  const handleCloseModal = () => setShowModal(false);

  const openModalToAddPan = (info) => {
    setGuestName(info.GuestName);
    setGuestID(info.guestID);
    setPanNo("");
    setShowModal(true);
  };

  const handleAddPan = async () => {
    if (!panNo) return toast.error("PAN number cannot be empty");

    try {
      await axios.post(`${url}/update_guest_pan`, {
        guest_id: guestID,
        guest_name: guestName,
        guest_pan: panNo,
        outlet: selectedOutlet,
        token: token
      });

      toast.success("PAN updated successfully");
      fetchSelectedData();
      handleCloseModal();
    } catch (error) {
      toast.error("Failed to update PAN");
      console.error(error);
    }
  };

  return (
    <div className="table-customer-list-responsive">
      <table className="table-customer-list">
        <thead>
          <tr className="position-sticky">
            {header.map((detail, index) => (
              <th key={index}>{detail}</th>
            ))}
            {/* <th><button><BsThreeDotsVertical /></button></th> */}
          </tr>
        </thead>
        <tbody>
          {similarCustomer.map((info, index) => (
            <tr
              className="position-sticky"
              id="q1button"
              tabIndex="1"
              key={index}
              onClick={() => handleDetails(info.guestID)}>
              <td>{info.guestID}</td>
              <td>{info.GuestName}</td>
              <td>{info.guestEmail}</td>
              <td>{info.guestAddress}</td>
              <td>{info.guestPhone}</td>
              <td>
                {info.guest_pan ? (
                  info.guest_pan
                ) : (
                  <div
                    className="italic text-blue-600 cursor-pointer hover:underline"
                    onClick={(e) => {
                      e.stopPropagation();
                      openModalToAddPan(info);
                    }}
                  >
                    Add Pan No.?
                  </div>
                )}
              </td>
              {/* <th><button ><AiOutlineEye /></button></th> */}
            </tr>
          ))}
        </tbody>
      </table>

      <Modal show={showModal} onHide={handleCloseModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Add Pan No</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <div>
              <label htmlFor="imageUpload" className="form-label">
                Customer Name
              </label>
              <input
                type="text"
                className="form-control"
                disabled
                value={guestName}
              />
            </div>
          </div>

          <div className="mb-3">
            <div>
              <label htmlFor="imageUpload" className="form-label">
                Pan No
              </label>
              <input
                type="text"
                className="form-control"
                value={panNo}
                onChange={(e) => setPanNo(e.target.value)}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={handleAddPan}
          >
            Add Pan
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SameCustomerList;
